var SortedMap = require("../collections/sortedMap.js");
var sanityCheckHandler = require("../observable/sanityCheckHandler.js");

var Root = function(){  // TODO: actually this is not really the root, rather the soil for this data! also maybe move this to observable: since this is only the observable root part
    this.data = null; // the node in this value is the actual root...

    this.handlers = {
        bubble: new SortedMap(),
        add: new SortedMap(),
        remove: new SortedMap()
    };
};

Root.prototype.attachData = function(data){ // TODO: maybe merge this in the constructor
    var self = this;
    this.data = data;
    this.data.onBubble("_bubbleToRoot", function(event){
        self.handlers.bubble.forEach(function(k, handler){
            handler.call(self, event);
        });
    });
    this.data._addToRoot(this);
};

Root.prototype.onBubble = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    this.handlers.bubble.put(key, handler, priority || 0);
};

Root.prototype.onAdd = function(key, handler, priority){
    sanityCheckHandler(arguments);
    this.handlers.add.put(key, handler, priority || 0);
};

Root.prototype.onRemove = function(key, handler, priority){
    sanityCheckHandler(arguments);
    this.handlers.remove.put(key, handler, priority || 0);
};

module.exports = Root;